// extracted by mini-css-extract-plugin
export default {"section":"PostCol_section__q+p0I","video":"PostCol_video__7nIAw","imgBox":"PostCol_imgBox__tXX+a","textBox":"PostCol_textBox__Y8MWJ"};